import './form.css'

import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

const resolveState = ({ error, diffStatus }) => {
  if (error) return 'error'
  if (diffStatus === 'new') return 'new'
  if (diffStatus === 'changed') return 'changed'
  return undefined
}

export const FieldWrapper = ({
  id,
  label,
  required,
  helper,
  error,
  diffStatus,
  ai = false,
  disabled,
  children
}) => {
  const state = resolveState({ error, diffStatus })
  const describedBy = [error ? `${id}-error` : null, helper && !error ? `${id}-helper` : null]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      className={`ff-field${disabled ? ' ff-field--disabled' : ''}`}
      data-state={state}
      data-field={id}
      data-ai={ai ? 'true' : undefined}
    >
      {label && (
        <label className="ff-field__label" htmlFor={id}>
          <span>{label}</span>
          {required && (
            <span className="ff-field__required" aria-hidden="true">
              *
            </span>
          )}
          {ai && (
            <span className="ff-field__ai-mark" aria-label={t.cpCompilatoDaNora}>
              <svg
                width="10"
                height="10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M12 2l2 5 5 2-5 2-2 5-2-5-5-2 5-2z" />
              </svg>
              Nora
            </span>
          )}
        </label>
      )}
      <div className="ff-field__control" aria-describedby={describedBy || undefined}>
        {children}
      </div>
      {error ? (
        <div className="ff-field__error" id={`${id}-error`} role="alert">
          {error}
        </div>
      ) : helper ? (
        <div className="ff-field__helper" id={`${id}-helper`}>
          {helper}
        </div>
      ) : (
        <div className="ff-field__helper" aria-hidden="true" />
      )}
    </div>
  )
}
